<template>
  <b-card>
    <b-row>
      <b-col
        cols="12"
        md="8"
      >
        <title-name />
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <purchase-offer-config-type-select />
      </b-col>
      <template v-if="itemData.config_type === 'user_select'">
        <b-col
          cols="12"
          md="6"
        >
          <purchase-offer-config-user-select />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <purchase-offer-config-value
            title="Değer"
            item="value_2"
            type="number"
          />
        </b-col>
      </template>
      <template v-else>
        <b-col
          cols="12"
          md="12"
        >
          <purchase-offer-config-value
            title="Değer"
            item="value"
            type="number"
          />
        </b-col>
      </template>
    </b-row>

  </b-card>
</template>

<script>
import { BCard, BRow, BCol } from 'bootstrap-vue'
import TitleName from '@/views/Admin/Defines/PurchaseOfferConfig/elements/Title.vue'
import PurchaseOfferConfigTypeSelect from '@/views/Admin/Defines/PurchaseOfferConfig/elements/ConfigTypeSelect.vue'
import PurchaseOfferConfigUserSelect from '@/views/Admin/Defines/PurchaseOfferConfig/elements/UserSelect.vue'
import PurchaseOfferConfigValue from '@/views/Admin/Defines/PurchaseOfferConfig/elements/Value.vue'

export default {
  name: 'ItemForm',
  components: {
    PurchaseOfferConfigValue,
    PurchaseOfferConfigUserSelect,
    PurchaseOfferConfigTypeSelect,
    BCard,
    BRow,
    BCol,
    TitleName,
  },
  computed: {
    itemData() {
      return this.$store.getters['purchaseOfferConfig/dataItem']
    },
  },
}
</script>
